import { render, staticRenderFns } from "./CustomerWorkshopScheduleList.vue?vue&type=template&id=4f27027d&"
import script from "./CustomerWorkshopScheduleList.vue?vue&type=script&lang=js&"
export * from "./CustomerWorkshopScheduleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports